import * as yup from 'yup'

export const schemaFormMarkAsPaid = yup.object({
  amountPaid: yup.string().required('Valor pago é obrigatório.'),
  comment: yup.string(),
  datePaid: yup.date().required('Data de pagamento é obrigatória.'),
  directType: yup.object({
    label: yup.string().required('Meio de recebimento é obrigatório.'),
    value: yup.string().required('Meio de recebimento é obrigatório.')
  })
})
